import AudiLogo from "./audi-logo";
import CupraLogo from "./cupra-logo";
import NfzLogo from "./nfz-logo";
import PorscheLogo from "./porsche-logo";
import { RauchLogoWhite } from "./rauch-logo";
import { SchuetzLogoWhite } from "./schuetz-logo";
import SeatLogo from "./seat-logo";
import SkodaLogo from "./skoda-logo";
import VolkswagenLogo from "./volkswagen-logo";
import { WiestLogo, WiestLogoWhite } from "./wiest-logo";

export {
  AudiLogo,
  CupraLogo,
  NfzLogo,
  PorscheLogo,
  RauchLogoWhite,
  SchuetzLogoWhite,
  SeatLogo,
  SkodaLogo,
  WiestLogo,
  WiestLogoWhite,
  VolkswagenLogo,
};
